import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { returnToDrayage } from '../../service/drayage-sso';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthApiService } from '../../service/auth-api.service';
import { environment } from '../../../../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'common-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  encapsulation: ViewEncapsulation.None, // Reduces style processing
})
export class LoginComponent {
  @Input() useType: any;
  @Output() changeEmit = new EventEmitter();
  loginFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', Validators.email),
    password: new UntypedFormControl('', Validators.required),
    otp: new UntypedFormControl('', Validators.required),
  });
  postObj = {
    email: "",
    password: "",
    type: "email",
    mobile_no: ""
  };
  isCheckingMailid: boolean = false;
  errorMessage: string = "";
  passwordErrorCallback: string = "";
  otpErrorCallback: string = "";
  emailErrorCallback: string = ""
  passwordOpen: boolean = false;
  isSubmiting: boolean = false;
  projectType: any = 'login';
  selectedValue: any = "+91";
  filePath = environment.filePath;
  resetFormGroup = new UntypedFormGroup({
    repassword: new UntypedFormControl('', [Validators.required]),
    password: new UntypedFormControl('', Validators.required)
  });
  setPasswordFormGroup = new UntypedFormGroup({
    password: new UntypedFormControl('', Validators.required),
  });
  resetEmail = new UntypedFormControl('', [Validators.required, Validators.email]);
  resetPasswordFocus = false;
  passFieldType = 'password';
  passwordMatchError = {
    number_symbol: false,
    len: false,
    letter: false,
    password_match: false
  };
  setPasswordUserId: any;
  isLoadingAppinfo: boolean = false;
  otpValue = '';
  token: any;
  spinner: boolean = false;
  AppInfo: any;
  isCheckingRestLInk: boolean = false;
  loginTypeOtp: boolean = false;
  constructor(private as: AuthApiService, private route: Router,
    private routeActive: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit() {
    this.getAppInfo();
    this.routeActive.queryParams.subscribe(params => {
      // drayage's Logout lands here with logout=1: end the Atmavaan session too (same keys as the navbar's sign out)
      if (params['logout'] == '1' && isPlatformBrowser(this.platformId)) {
        ['x-token', 'user', 'theme', 'redirectUrl'].forEach(k => localStorage.removeItem(k));
        this.as.notifyUserChanged();
      }
      if (!!params['action']) { this.projectType = params['action']; }
      this.token = params['token'];
      if (!!this.projectType && this.projectType == 'set_password') {
        if (this.token) {
          this.validateSetPasswordLink();
        }
      } else if (!!this.projectType && this.projectType == 'reset') {
        if (this.token) {
          this.validateRestLink();
        }
      }
    });
  }

  ngOnDestroy() {
    this.stopTimer();
  }

  validateSetPasswordLink() {
    let obj = {
      token: this.token,
      type: 'set_password'
    }
    this.isCheckingRestLInk = true;
    this.as.validateRestLink(obj).subscribe(res => {
      if (res.statusCode == 200) {
        this.isCheckingRestLInk = false;
        if (!!res.info && !!res.info.id) {
          this.loginFormGroup.value.email = res.info.email;
          this.setPasswordFormGroup.value.email = res.info.email;
          this.setPasswordUserId = res.info.id;
        } else if (!!res.error_code && res.error_code == 'password_exit') {
          this.projectType = 'password_exit';
          this.errorMessage = res.error_message;
        } else if (!!res.error_code && res.error_code == 'invalid_password_link') {
          this.projectType = 'invalid_password_link';
          this.errorMessage = res.error_message;
        }
      } else {
        this.isCheckingRestLInk = false;
      }

    })
  }

  validateRestLink() {
    let obj = {
      token: this.token,
      type: 'reset_password'
    }
    this.isCheckingRestLInk = true;
    this.as.validateRestLink(obj).subscribe(res => {
      if (res.statusCode == 200) {
        this.isCheckingRestLInk = false;
        if (!!res.error_code && res.error_code == 'invalid_token_link') {
          this.projectType = 'invalid_token_link';
          this.errorMessage = res.error_message;
        } else {
          this.projectType == 'reset'
          this.token = obj['token'];
        }
      } else {
        this.isCheckingRestLInk = false;
      }

    })
  }
  getAppInfo() {
    this.isLoadingAppinfo = true;
    if (isPlatformBrowser(this.platformId)) {
      let domain = window.location.host;
      // console.log
      this.as.getAppInfo(domain).subscribe(res => {
        if (res.statusCode == 200) {
          this.isLoadingAppinfo = false;
          this.AppInfo = res.info;
          localStorage.setItem("appInfo", JSON.stringify(this.AppInfo))
        }
      });
    }
  }

  async login() {
    this.emailErrorCallback = '';
    this.passwordErrorCallback = '';
    this.otpErrorCallback = '';

    let validatedList = <any>[];
    if (this.loginTypeOtp) {
      if (this.loginFormGroup.controls['email'].status != "VALID" || !this.loginFormGroup.controls['email'].value) {
        this.emailErrorCallback = 'Please enter a vaild email ID';
        validatedList.push("");
      }
      if (this.loginFormGroup.controls['otp'].status != "VALID" || !this.loginFormGroup.controls['otp'].value) {
        this.otpErrorCallback = 'Please enter a vaild OTP'
        validatedList.push("");
      }

    } else {
      if (!this.loginFormGroup.valid) {
        if (this.loginFormGroup.controls['email'].status != "VALID" || !this.loginFormGroup.controls['email'].value) {
          this.emailErrorCallback = 'Please enter a vaild email ID';
          validatedList.push("");
        }
        if (this.loginFormGroup.controls['password'].status != "VALID") {
          this.passwordErrorCallback = 'Password is required';
          validatedList.push("");
        }
      } else {
        validatedList.push("");
      }
    }
    if (!validatedList.length) {
      this.spinner = true;
      this.isSubmiting = true;
      const body: any = {};
      Object.assign(body, this.loginFormGroup.value);
      // if (Notification.permission === "granted") {
      //   //  Check and get fcm token and sent to backend
      //   let v = await this.as.getFCMToken();
      //   if (!!v) {
      //     body['fcm_token'] = v
      //   }
      // }
      if (!!body["otp"]) {
        body["otp"] = body["otp"] + '';
      }
      body["franchise"] = this.AppInfo.id + '';
      body["login_type"] = this.loginTypeOtp ? 'otp' : 'password';
      this.as.login(body).subscribe(res => {
        if (res.statusCode === 200 && !res.error_code) {
          this.afterLoginPageSet(res.info);
          this.isSubmiting = false;
          this.spinner = false;
          // this.toastService.success('Logged in Successfully');
        } else {
          this.isSubmiting = false;
          this.spinner = false;
          this.errorMessage = res.error_message;
          if (res.error_code == 'invalid_password') {
            this.passwordErrorCallback = res.error_message
          } else if (res.error_code == 'invalid_email') {
            this.emailErrorCallback = res.error_message;
          } else if (res.error_code == 'invalid_credential') {
            this.emailErrorCallback = res.error_message;
          } else if (res.error_code == 'invalid_otp') {
            this.otpErrorCallback = res.error_message;
          }
        }
      })
    }

  }

  // After successfull login handle
  // afterLoginPageSet(res: any) {
  //   localStorage.setItem('user', JSON.stringify(res.user));
  //   localStorage.setItem('x-token', res.token);
  //   if (!!this.useType && this.useType == 'popup') {
  //     console.log(this.useType)
  //     this.changeEmit.emit('login_success');
  //   } else {
  //     console.log(this.useType)
  //     this.route.navigate(['/main/home']);
  //   }
  // }

  // After successful login handle
  afterLoginPageSet(res: any) {
    localStorage.setItem('user', JSON.stringify(res.user));
    localStorage.setItem('x-token', res.token);
    if (!!res.app_theme) {
      localStorage.setItem('theme', res.app_theme);
    } else {
      localStorage.setItem('theme', "light");
    }
    this.syncTokenToWebsite(res.token);
    const redirectUrl = localStorage.getItem('redirectUrl');
    this.as.notifyUserChanged();
    // opened by drayage (?redirectUrl=...): go back there signed in
    if (returnToDrayage(res.token, this.routeActive.snapshot.queryParamMap.get('redirectUrl'))) {
      return;
    }

    if (!!this.useType && this.useType == 'popup') {
      this.changeEmit.emit('login_success');
    } else {
      // console.log(this.useType)
      // this.route.navigate(['/main/home']);
      if (!!redirectUrl && !redirectUrl.includes("/login")) {
        this.route.navigateByUrl(redirectUrl);
        localStorage.removeItem('redirectUrl');
      } else {
        this.route.navigate(['/main']);
      }
    }
  }

  private syncTokenToWebsite(token: string): void {
    const host = isPlatformBrowser(this.platformId) ? window.location.hostname : '';
    const isPortalHost = host.includes('drayage') || host.startsWith('app.') || host === 'localhost';
    if (isPlatformBrowser(this.platformId) && isPortalHost) {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = 'https://www.atmavaan.com/sso-sync?token=' + encodeURIComponent(token);
      // iframe.src = 'http://localhost:35787/sso-sync?token=' + encodeURIComponent(token);
      document.body.appendChild(iframe);
    }
  }

  // keep drayage's ?redirectUrl when switching to sign-up, so signing up still returns there
  private drayageParams(): any {
    const redirectUrl = this.routeActive.snapshot.queryParamMap.get('redirectUrl');
    return redirectUrl ? { redirectUrl } : {};
  }

  signup() {
    this.changeEmit.emit('close');
    // this.projectType = 'reset'
    this.route.navigate(['/auth/signup'], { queryParams: this.drayageParams() });
  }

  resetLink() {
    this.spinner = true
    this.errorMessage = '';
    if (this.resetEmail.status == "INVALID") {
      this.errorMessage = 'Please type your mail Id';
      this.spinner = false;
    } else {
      this.isSubmiting = true;
      let body = {
        'email': this.resetEmail.value
      }
      body["franchise"] = this.AppInfo.id + '';
      this.as.forgetPassword(body).subscribe((res) => {
        if (res.statusCode === 200 && !res.error_code) {
          this.projectType = 'sent_email';
          // this.toastService.warn('Reset link has been sent to your mail');
        } else {
          this.errorMessage = res.error_message;
        }
        this.isSubmiting = false;
        this.spinner = false;
      });
    }
  }

  isResetButtonDisabled(): boolean {
    return Object.values(this.passwordMatchError).some(value => !value);
  }

  passwordValid() {
    if (!!this.resetFormGroup.value.password.match(/[0-9]+/) &&
      !!this.resetFormGroup.value.password.match(/[-!$%^&*@#()_+|~=`{}\[\]:";'<>?,.\/]/)) {
      this.passwordMatchError.number_symbol = true;
    } else {
      this.passwordMatchError.number_symbol = false;
    }

    if (!!this.resetFormGroup.value.password.match(/[a-z]/) && !!this.resetFormGroup.value.password.match(/[A-Z]/)) {
      this.passwordMatchError.letter = true;
    } else {
      this.passwordMatchError.letter = false;
    }

    if (this.resetFormGroup.value.password.length >= 8) {
      this.passwordMatchError.len = true;
    } else {
      this.passwordMatchError.len = false;
    }

    if (this.resetFormGroup.value.password == this.resetFormGroup.value.repassword) {
      this.passwordMatchError.password_match = true;
    } else {
      this.passwordMatchError.password_match = false;
    }

  }

  setPasswordVaildChecker(): boolean {
    return Object.values(this.passwordMatchError).some(value => !value);
  }

  createpasswordValid() {
    if (!!this.setPasswordFormGroup.value.password.match(/[0-9]+/) &&
      !!this.setPasswordFormGroup.value.password.match(/[-!$%^&*@#()_+|~=`{}\[\]:";'<>?,.\/]/)) {
      this.passwordMatchError.number_symbol = true;
    } else {
      this.passwordMatchError.number_symbol = false;
    }

    if (!!this.setPasswordFormGroup.value.password.match(/[a-z]/) && !!this.setPasswordFormGroup.value.password.match(/[A-Z]/)) {
      this.passwordMatchError.letter = true;
    } else {
      this.passwordMatchError.letter = false;
    }

    if (this.setPasswordFormGroup.value.password.length >= 8) {
      this.passwordMatchError.len = true;
    } else {
      this.passwordMatchError.len = false;
    }

    this.passwordMatchError.password_match = true;
  }



  changeNewPassword() {
    this.errorMessage = '';
    this.isSubmiting = true;
    // this.projectType = 'reset_success';
    if ((this.passwordMatchError.number_symbol && this.passwordMatchError.letter && this.passwordMatchError.len)) {
      if (this.resetFormGroup.value.password === this.resetFormGroup.value.repassword) {
        const body = {
          token: this.token,
          password: this.resetFormGroup.value.password
        };
        this.as.newPasswordUpdate(body).subscribe(res => {
          if (res.statusCode === 200 && !res.error_code) {
            this.projectType = 'login';
            this.projectType = 'reset_success'
          } else {
            this.projectType = 'invalid_token_link';
            this.errorMessage = res.error_message;
          }
          this.isSubmiting = false;
        });
      } else {
        this.isSubmiting = false;
        this.errorMessage = 'Passwords did not match';
      }
    } else {
      this.isSubmiting = false;
      this.errorMessage = 'Please follow all the given Conditions';
    }
  }

  // Click to view forgetpassword page
  forgetPassword() {
    this.isSubmiting = false;
    this.errorMessage = '';
    this.projectType = 'forgot';
    this.resetEmail.setValue(this.loginFormGroup.value.email);
  }

  onForgetPassword() {
    this.projectType = 'forgot';
    const emailValue = this.loginFormGroup.get('email')?.value;
    this.resetEmail.setValue(emailValue);
  }
  backToLogin() {
    this.route.navigate(['/auth/login']);
  }

  otpResendTimer: number = 0; // Timer in seconds
  isTimerRunning: boolean = false;
  timerId: any; // To hold the interval ID

  startTimer() {
    this.otpResendTimer = 50;
    this.isTimerRunning = true;
    this.timerId = setInterval(() => {
      if (this.otpResendTimer > 0) {
        this.otpResendTimer--;
      } else {
        this.stopTimer();
      }
    }, 1000); // Decrease the timer every second
  }

  stopTimer() {
    clearInterval(this.timerId); // Stop the interval
    this.isTimerRunning = false;
  }
  otpTimmer() {
    if (!this.isTimerRunning) {
      this.otpResendTimer = 50; // Reset the timer
      this.startTimer(); // Restart the timer
    }
  }
  changeLoginType() {
    this.isSubmiting = false;
    this.spinner = false;
    this.loginTypeOtp = !this.loginTypeOtp;
    if (this.loginTypeOtp) {
      this.validateForOTP(1);
    } else {
      this.submittedOTPRequest = false;
      this.gotOTP = false;
      this.stopTimer();
    }
  }

  validateForOTP(flag = 0) {
    this.emailErrorCallback = '';
    if (!this.loginFormGroup.valid) {
      if (this.loginFormGroup.controls['email'].status != "VALID" || !this.loginFormGroup.controls['email'].value) {
        this.emailErrorCallback = flag ? '' : 'Please enter a vaild email ID';
      } else {
        this.isSubmiting = true;
        this.spinner = true;
        this.getOTP();
      }
    }
  }

  submittedOTPRequest: boolean = false;
  gotOTP: boolean = false;
  getOTP() {
    this.isSubmiting = true;
    this.spinner = true;
    let body = {};
    this.gotOTP = false;
    this.stopTimer();
    Object.assign(body, this.loginFormGroup.value);
    body["franchise"] = this.AppInfo.id + '';
    this.as.loginOTP(body).subscribe(res => {
      if (res.statusCode == 200 && !res.error_code) {
        this.otpTimmer();
        this.isSubmiting = false;
        this.spinner = false;
        this.gotOTP = true;
        this.submittedOTPRequest = true;
      } else if (!!res.error_code) {
        this.isSubmiting = false;
        this.spinner = false;
        this.emailErrorCallback = res.error_message;
      }
    })
  }
  changeMailId() {
    this.submittedOTPRequest = false;
    this.isSubmiting = false;
    this.spinner = false;
    this.gotOTP = false;
  }
  resetPassowrdTOLoginOTP() {
    this.projectType = 'login';
    this.route.navigate(['/auth/login']);
    this.isSubmiting = false;
    this.spinner = false;
    this.loginTypeOtp = true;
  }
  setPasswordPending: boolean = false;
  checkUserExist() {
    let body = {
      "value": this.loginFormGroup.value["email"],
      "franchise": this.AppInfo.id,
      "type": "mailId_status"
    }
    if (!!this.loginFormGroup.value["email"] && this.loginFormGroup.value["email"].includes("@")) {
      this.isCheckingMailid = true;
      this.setPasswordPending = false;
      this.errorMessage = "";
      this.emailErrorCallback = "";
      this.as.checkUserExist(body).subscribe((res) => {
        if (res.statusCode == 200) {
          this.isCheckingMailid = false;
          if (!!res.info && !!res.info.error_code) {
            if (res.info.error_code == "set_password") {
              this.setPasswordPending = true;
            } else if (res.info.error_code == "invalid_email") {
              this.errorMessage = res.info.error_message;
              this.emailErrorCallback = res.info.error_message;
            }
          }
        }
      })
    }

  }
  setCreatePassword() {
    let obj = {
      email: this.loginFormGroup.value.email,
      password: this.setPasswordFormGroup.value.password,
      franchise: this.AppInfo.id,
      id: this.setPasswordUserId
    }
    this.setPasswordPending = false;
    this.as.createPassword(obj).subscribe(res => {
      if (res.statusCode === 200 && !res.error_code) {
        this.projectType = 'login';
        this.projectType = 'reset_success'
      } else {
        this.projectType = 'invalid_token_link';
        this.errorMessage = res.error_message;
      }
      this.isSubmiting = false;
    });
  }
}
